import { render, staticRenderFns } from "./InnoverLegends.vue?vue&type=template&id=6dbf1cd1&scoped=true"
import script from "./InnoverLegends.vue?vue&type=script&lang=js"
export * from "./InnoverLegends.vue?vue&type=script&lang=js"
import style0 from "./InnoverLegends.vue?vue&type=style&index=0&id=6dbf1cd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf1cd1",
  null
  
)

export default component.exports